import {changeEvent, customDocumentEvent} from "../../../../webpack/modules/events";
import {ga4TrackSimpleEvent} from "../../../../webpack/modules/analytics";
import {updateExclusivePremiumProducts} from "../../../../webpack/modules-optimized/product-list";
import {displayProductProductListImages, displayRoomProductListImages} from "../../../../webpack/modules-optimized/product-list";

customDocumentEvent('userInfoLoaded', function() {
    updateExclusivePremiumProducts(document.querySelector('#product-list-page #list-products'));
});

changeEvent('#product-list-page .image-display-selector', false, function(element) {
    let container = document.querySelector('#product-list-page');
    let listType = container.classList.contains('search-results') ? 'search_results' : 'product_list';
    let imageDisplay = element.value;
    let contentType = imageDisplay === 'product' ? 'product' : 'room';

    container.querySelectorAll(`.image-display-selector:not([value=${imageDisplay}])`).forEach((radio) => radio.checked = false);
    container.querySelectorAll(`.image-display-selector[value=${imageDisplay}]`).forEach((radio) => radio.checked = true);

    if (imageDisplay === 'product') displayProductProductListImages();
    else if (imageDisplay === 'room') displayRoomProductListImages();

    ga4TrackSimpleEvent({
        'event': listType,
        'method': 'product_vision',
        'content_type': contentType
    });
});